import createIsDirty from '../selectors/isDirty';
import immutable from '../structure/immutable';

export default createIsDirty(immutable);


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/immutable/isDirty.js
// module id = 1205
// module chunks = 0